import { Phone, Globe, MapPin } from "lucide-react";
import { Reveal } from "./Reveal";
import Flourish from "./Flourish";
import { contact } from "../data/menuData";

export default function Footer() {
  return (
    <footer
      data-testid="footer"
      className="relative bg-ink border-t border-gold-primary/15 overflow-hidden"
    >
      <Flourish className="absolute -bottom-6 -left-6 w-40 md:w-64 opacity-70" />
      <Flourish className="absolute -top-6 -right-6 w-40 md:w-64 opacity-70" flip />

      <div className="relative z-10 mx-auto max-w-7xl px-6 md:px-10 py-24 md:py-32">
        <Reveal>
          <p className="font-body text-xs tracking-[0.35em] uppercase text-gold-muted mb-6">
            Visit Us
          </p>
          <h2 className="font-heading font-light text-5xl sm:text-6xl md:text-7xl leading-[0.9] text-foreground">
            We can&rsquo;t wait to
            <br />
            <span className="italic gold-gradient-text font-accent">
              pamper you.
            </span>
          </h2>
        </Reveal>

        <div className="mt-16 md:mt-20 grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8 border-t border-gold-primary/15 pt-14">
          <Reveal>
            <p className="text-[0.7rem] tracking-[0.3em] uppercase text-gold-primary/80 mb-4">
              Call
            </p>
            <a
              data-testid="footer-phone"
              href={contact.phoneHref}
              className="inline-flex items-center gap-3 font-heading text-2xl md:text-3xl text-foreground hover:text-gold-light transition-colors duration-300"
            >
              <Phone className="w-5 h-5 text-gold-primary" />
              {contact.phone}
            </a>
          </Reveal>

          <Reveal delay={0.1}>
            <p className="text-[0.7rem] tracking-[0.3em] uppercase text-gold-primary/80 mb-4">
              Online
            </p>
            <a
              data-testid="footer-website"
              href={contact.websiteHref}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 font-heading text-2xl md:text-3xl text-foreground hover:text-gold-light transition-colors duration-300"
            >
              <Globe className="w-5 h-5 text-gold-primary" />
              {contact.website}
            </a>
          </Reveal>

          <Reveal delay={0.2}>
            <p className="text-[0.7rem] tracking-[0.3em] uppercase text-gold-primary/80 mb-4">
              Location
            </p>
            <a
              data-testid="footer-address"
              href={contact.mapHref}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-start gap-3 font-heading text-xl md:text-2xl leading-snug text-foreground hover:text-gold-light transition-colors duration-300"
            >
              <MapPin className="w-5 h-5 text-gold-primary mt-1 shrink-0" />
              {contact.address}
            </a>
          </Reveal>
        </div>

        <div className="mt-20 flex flex-col md:flex-row items-center md:items-baseline justify-between gap-4 text-xs text-foreground/60">
          <img
            src="/bq-logo.png"
            alt="BQ Nails & Spa"
            className="h-16 w-auto object-contain"
          />
          <span>&copy; {new Date().getFullYear()} BQ Nails &amp; Spa. All rights reserved.</span>
        </div>
      </div>
    </footer>
  );
}
